import { render, staticRenderFns } from "./station-detail-construction.vue?vue&type=template&id=6687d13e&scoped=true&"
import script from "./station-detail-construction.vue?vue&type=script&lang=js&"
export * from "./station-detail-construction.vue?vue&type=script&lang=js&"
import style0 from "./station-detail-construction.vue?vue&type=style&index=0&id=6687d13e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6687d13e",
  null
  
)

export default component.exports